import React, {useState, useEffect} from 'react';
import { createRoot } from 'react-dom/client';
import ProductSearch from "../components/ProductSearch";
import Modal from "react-modal";

function Buttons(props) {
    const {model, fullPriceOI} = props;
    const condition = fullPriceOI == model.sum;

    return <div className="bag__total">
        <div className="bag__total-list">
            <div className="bag__total-item">
                <div className="bag__total-label">Скидка {model.discount_description}</div>
                <div className="bag__total-value">
                    {model.sum && fullPriceOI
                        ? parseFloat((fullPriceOI - model.product_sum) / fullPriceOI * 100).toFixed(2)
                        : 0
                    } %
                </div>
            </div>
            {model.promocodeDiscount ? <div className="bag__total-item">
                <div className="bag__total-label bag__total-label--flex">
                    <span>Скидка по промокоду</span>
                    <img className='bag__total-question' src="/img/icons/question.svg" title='Промокод применяется к финальной цене' alt="question"/> 
                </div>
                <div className="bag__total-value">{model.promocodeDiscount} %</div>
            </div> : null}
            <div className="bag__total-item">
                <div className="bag__total-label bag__total-label--flex" style={{justifyContent: 'end'}}>
                    Сумма заказа
                    {condition ? null : <img className='bag__total-question' src="/img/icons/question.svg" title='Скидка может применяться не на все товары' alt="question"/>}
                </div>
                {
                    condition
                        ? <div className="bag__total-value">{model.sum} руб </div>
                        : <div className="bag__total-value">
                            <s>{ fullPriceOI }</s> руб
                            <p>{model.sum} руб </p>
                        </div>
                }
            </div>
        </div>
    </div>
}

export default function OrderIndex(props) {
    let {
        enableButtons,
        orderId,
        leftInStock,
        canAddProducts,

        updateExternal, // for internal using
        modelExternal, // for internal using
    } = props;

    let model, setModel;

    [model, setModel] = useState({
        orderItems: [],
        test: 'test'
    });

    let [promocode, setPromocode] = useState('');
    const [fullPriceOI, setfullPriceOI] = useState()

    if (modelExternal) {
        model = modelExternal;
    }

    if (enableButtons === undefined) {
        enableButtons = 1;
    }

    let [showProductModal, setShowProductModal] = useState(false);

    let formatPrice = (num) => {
        let tString = "" + num;
        let output = "";
        for (var i = tString.length - 1; i--; i !== 0) {
            if (i % 3 === 0 && i !== 0) {
                output = " " + tString[i]
            }
            output = output + tString[i]
        }
    }

    let update = () => {
        if (updateExternal) {
            updateExternal();
        }

        $.get('/order-api/get-data', {order_id: orderId}, (data) => {
            setModel(data);
            setPromocode(data.promocode);
            let fullPrice = 0;
            data.orderItems.map((item) => {
                fullPrice += item.originPrice * item.count
            })

            setfullPriceOI(fullPrice);
        });

        if (window.checkout__reloadData) {
            window.checkout__reloadData();
        }
    };

    let deleteOrderItem = (id) => {
        if (confirm('Удалить позицию из корзины?')) {
            var $this = this;
            $.get('/order/delete', {id: id, order_id: orderId}, function () {
                update();
            });
        }
    };

    let plus = (id) => {

        $.get('/order/plus', {id: id, order_id: orderId}, function (data) {
            if (data.status === 'ok') {
                update();
            } else {
                toastr.error(data.error);
            }
        });
    };

    let minus = (id, order) => {

        var cancel = false;

        if (order) {
            var found = _.find(order.orderItems, function (i) {
                return i.id === id
            });

            if (found && found.count - 1 <= 0) {
                cancel = true;
            }
        }

        if (!cancel) {
            $.get('/order/minus', {id: id, order_id: orderId}, function () {
                update();
            });
        }
    };

    /**
     * Добавление нового товара
     * @param ps объект ProductSize
     */
    let addNewProduct = (ps) => {
        // console.log('add new product ps', ps);
        setShowProductModal(false); // Закрыть модалку с товарами

        $.get('/order-api/add-new-product', {
            product_size_id: ps.id,
            order_id: orderId
        }, () => {
            update();
        });
    };

    // Применить промокод
    let applyPromo = () => {
        $.post('/order-api/set-promo', {
            code: promocode,
        }, (data) => {
            if (data.success && promocode.length > 0) {
                window.toastr.success('Промокод применён');
                update();
            } else {
                window.toastr.error('Не удалось применить промокод');
                setPromocode('');
                update();
            }
        });
    }

    useEffect(() => {
        update();
    }, []);

    return <div className="bag">
        <div className="bag__container">
            <div className="title">
                <h1>Корзина</h1>
            </div>

            {
                canAddProducts ? <div>
                    <a href='#' onClick={
                        event => {
                            event.preventDefault();
                            setShowProductModal(true);
                        }
                    }>Добавить товар</a>
                    <Modal
                        isOpen={showProductModal}
                        onRequestClose={() => setShowProductModal(false)}
                    >
                        <ProductSearch onSelect={addNewProduct}/>
                    </Modal>
                </div> : null
            }

            {
                model.orderItems.length === 0 ? <div className="bag__empty">
                    Ваша корзина пуста
                </div> : null
            }

            <div className="bag__table">
                <div className="bag__items">
                    {
                        model.orderItems.map(orderItem => {
                            let cnt = orderItem.count;
                            if (leftInStock) {
                                cnt += ` (${orderItem.left_in_stock})`;
                            }

                            let _product_price = orderItem.product_price_discount !== orderItem.originPrice ?
                                <div>

                                                    <span
                                                        style={{textDecoration: 'line-through'}}>{orderItem.originPrice}
                                                        руб</span>

                                    <div>
                                        {orderItem.product_price_discount} руб
                                        <br/>
                                        <div
                                            dangerouslySetInnerHTML={{__html: orderItem.product_price_discount_description}}
                                        />
                                    </div>
                                </div> :
                                <div>
                                    {orderItem.product_price} руб
                                </div>;

                            // find shipping for current orderItem
                            let shipping = model.shippings.find(item => item.id === orderItem.shipping_id);

                            return <div key={orderItem.id} className="bag__item">
                                <div className="bag__thumb">
                                    <a href={orderItem.product.url}
                                       className="bag__link">

                                        <img src={orderItem.product.image}
                                             alt={`${orderItem.productType} ${orderItem.productName}`}
                                             className="bag__img"/>

                                    </a>
                                    <div className="bag__options bag__options--sm">
                                        <a className="bag__options-link" href="#"
                                           onClick={e => {
                                               e.preventDefault();
                                               deleteOrderItem(orderItem.id)
                                           }}>Удалить
                                        </a>
                                    </div>

                                </div>
                                <div className="bag__details">
                                    <div className="bag__info">
                                        <a href={orderItem.product.url} target="_blank" className="bag__info-name">
                                            {orderItem.productType ? <span
                                                v-if="orderItem.productType">{orderItem.productType.name}</span> : null}
                                            {orderItem.productName}

                                            {
                                                shipping ? <span className="bag__info-tag">
                                                    {shipping.additionalName}
                                                </span> : null
                                            }
                                        </a>
                                        <ul className="bag__info-list">
                                            <li className="bag__info-item">
                                                <div className="bag__info-label">Материал:</div>
                                                <div className="bag__info-value">{orderItem.product.materials}</div>
                                            </li>
                                            <li className="bag__info-item">
                                                <div className="bag__info-label">Цвет:</div>
                                                <div className="bag__info-value">{orderItem.color}</div>
                                            </li>
                                            <li className="bag__info-item">
                                                <div className="bag__info-label">Размер:</div>
                                                <div className="bag__info-value">{orderItem.size}</div>
                                            </li>
                                            <li className="bag__info-item">
                                                <div className="bag__info-label">Артикул:</div>
                                                <div className="bag__info-value">{orderItem.productArticul}</div>
                                            </li>
                                            <li className="bag__info-item bag__info-item--lg">
                                                <div className="bag__info-label">Цена:</div>
                                                <div className="bag__info-value">
                                                    {_product_price}
                                                </div>
                                            </li>
                                            <li className="bag__info-item bag__info-item--md">
                                                <div className="bag__info-label">Сумма:</div>
                                                <div
                                                    className="bag__info-value">
                                                    {orderItem.product_price_discount * orderItem.count} руб
                                                </div>
                                            </li>

                                            <li className="bag__info-item bag__info-item--md">
                                                <div className="bag__info-label">Кол-во:</div>
                                                <div className="bag__info-value">
                                                    <div className="bag__qty">
                                                        <div className="bag__qty-minus bag__qty-button"
                                                             onClick={() => minus(orderItem.id)}
                                                        />
                                                        <input type="text" className="bag__qty-value"
                                                               value={cnt} readOnly/>
                                                        <div className="bag__qty-plus bag__qty-button"
                                                             onClick={() => plus(orderItem.id)}
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="bag__column bag__column--md">
                                        <div className="bag__title">Кол-во</div>
                                        <div className="bag__column-in">
                                            <div className="bag__qty">
                                                <div onClick={() => minus(orderItem.id)}
                                                     className="bag__qty-minus bag__qty-button"/>
                                                <input
                                                    readOnly
                                                    type="text"
                                                    className="bag__qty-value"
                                                    value={cnt}/>
                                                <div onClick={() => plus(orderItem.id)}
                                                     className="bag__qty-plus bag__qty-button"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bag__column bag__column--lg">
                                        <div className="bag__title">Цена</div>
                                        <div className="bag__column-in">
                                            <div className="bag__value">
                                                {_product_price}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bag__column bag__column--md">
                                        <div className="bag__title">Скидка</div>
                                        <div className="bag__column-in">
                                            <div className="bag__value">
                                                { parseFloat((orderItem.originPrice - orderItem.product_price_discount) / orderItem.originPrice * 100).toFixed(2) } %
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bag__column bag__column--md">
                                        <div className="bag__title">Сумма</div>
                                        <div className="bag__column-in">
                                            <div className="bag__value">
                                                {orderItem.product_price_discount * orderItem.count} руб
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bag__column">
                                        <div className="bag__options">
                                            <a className="bag__options-link" onClick={e => {
                                                e.preventDefault();
                                                deleteOrderItem(orderItem.id)
                                            }}
                                               href="#">Удалить</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                    }
                </div>
                <div className={'bag__promo'}>
                    <label form={'input-promocode'}>Промокод:</label>
                    <input
                        id={'input-promocode'}
                        type="text"
                        className="form__input"
                        placeholder={'Промокод'}
                        value={promocode}
                        onChange={e => setPromocode(e.target.value)}
                    />
                    <button onClick={applyPromo} className={'button'}>Применить</button>
                </div>

                {
                    enableButtons ? <Buttons model={model} fullPriceOI={fullPriceOI} /> : null
                }

            </div>



            {
                enableButtons ? <div className="bag__cta">
                    <a
                        href="/catalog/"
                        className="bag__cta-back button button--beige-line button--icon-left"
                    >
                        <svg className="icon icon--arrow-sm">
                            <use xlinkHref="#i-arrow-sm"/>
                        </svg>
                        <span>Продолжить покупки</span>
                    </a>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <a href="/order/checkout"
                           className="bag__cta-checkout button button--icon-right"
                           style={{marginBottom: '5px'}}>
                            Оформить заказ
                            <svg className="icon icon--arrow-sm">
                                <use xlinkHref="#i-arrow-sm"/>
                            </svg>
                        </a>
                    </div>
                </div> : null
            }
        </div>
    </div>
}

// Экспортируем функцию инициализации для вызова из main.js
export function initOrderIndex(appContainer, props = {}) {
    const root = createRoot(appContainer);
    root.render(<OrderIndex {...props}/>);
}
